module.exports = __webpack_public_path__ + "static/trials-974d76607e549ee77aa5d1e1f38fc47b.png";